/**
 * Common utils needed for sprint flyouts
 */
import type { SprintUnit } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/sprints';
import { proxyContextSafeUrl } from '@atlassian/jira-portfolio-3-portfolio/src/common/api';
import { isDefined } from '@atlassian/jira-portfolio-3-portfolio/src/common/ramda';
import { SPRINT_STATES } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import './styles.module.css';

export {
	formatDateRange,
	formatSprintUTCTime,
	getLozengeContent,
	getLozengeAppearance,
	// eslint-disable-next-line jira/export/no-external-exports
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/sprints';

export const getSprintType = (sprint: SprintUnit) => {
	switch (sprint.state) {
		case SPRINT_STATES.ACTIVE:
		case SPRINT_STATES.CLOSED:
			return sprint.state;
		case SPRINT_STATES.FUTURE:
			return sprint.id === 'FUTURE' ? 'PROJECTED' : 'FUTURE';
		default:
			return sprint.state;
	}
};

export const generateSprintUrl = ({
	boardId,
	state,
	id,
	reportType,
}: SprintUnit): string | undefined => {
	let url = proxyContextSafeUrl(`/secure/RapidBoard.jspa?rapidView=${boardId}`);

	if (reportType === 'DISABLED') {
		return undefined;
	}

	if (state === SPRINT_STATES.CLOSED) {
		if (reportType === 'USE_REPORTS') {
			url += `&view=reporting&report=burnup&sprint=${id}`;
		} else {
			url += `&view=reporting&chart=sprintRetrospective&sprint=${id}`;
		}
	} else if (state === SPRINT_STATES.FUTURE) {
		url += '&view=planning';
	}
	return url;
};

export const generateSprintReportURL = ({
	boardId,
	reportType,
}: SprintUnit): string | undefined => {
	// Disable 'Velocity Insights' link if sprint doesn't contain boardId
	if (!isDefined(boardId) || reportType === 'DISABLED') {
		return undefined;
	}

	if (reportType === 'USE_REPORTS') {
		return proxyContextSafeUrl(
			`/secure/RapidBoard.jspa?rapidView=${boardId}&view=reporting&report=velocity`,
		);
	}

	return proxyContextSafeUrl(
		`/secure/RapidBoard.jspa?rapidView=${boardId}&view=reporting&chart=velocityChart`,
	);
};
